module.exports = __webpack_public_path__ + "media/images/chownow-0ccb98eef24cc454ec3101199afebe74.svg";